<script lang="ts">
	import Navbar from '$lib/components/navigation/Navbar.svelte';
	import Footer from '$lib/components/navigation/Footer.svelte';
	import { onMount } from 'svelte';
	import 'aos/dist/aos.css';
	import AOS from 'aos';
	import type { PageServerData } from './$types';
	import PopUp from '$lib/components/section/PopUp.svelte';
	import { Splide, SplideSlide } from '@splidejs/svelte-splide';
	import '@splidejs/svelte-splide/css';
	// import { initHeroHomeSwiper } from '$lib/js/swiper.js';
	export let data: PageServerData;
	let isDesktop = false;
	let information = data?.information;
	let offer = data?.offer;
	let room = data?.room;
	let seo = data?.seo;
	let splideRef: { go: (arg0: string) => void };
	let splideRefRoom: { go: (arg0: string) => void };

	function goNext() {
		splideRef.go('>');
	}

	function goPrev() {
		splideRef.go('<');
	}
	function goRoomNext() {
		splideRefRoom.go('>');
	}

	function goRoomPrev() {
		splideRefRoom.go('<');
	}

	onMount(() => {
		isDesktop = window.innerWidth >= 1024;
		// initHeroHomeSwiper();
	});
	onMount(() => {
		if (window.innerWidth >= 1024) {
			AOS.init({
				duration: 1000,
				once: false
			});
		}
	});

	onMount(async () => {
		try {
			const res = await fetch('https://ipapi.co/json');
			const data = await res.json();

			if (data.country_name) {
				document.cookie = `country=${data.country_name}; path=/; max-age=86400`;
			}
		} catch (error) {
			console.error('Failed to fetch country info:', error);
		}
	});
</script>

<svelte:head>
	<title>{seo.data[0].title.hometit || 'Home - Trans Resort Bali'}</title>

	<meta name="title" content={seo.data[0].meta_title.homemetit || 'Trans Resort Bali'} />
	<meta
		name="description"
		content={seo.data[0].meta_description.homemetdesc ||
			"Stay at The Trans Resort Bali, just 10km from Ngurah Rai Airport. Enjoy luxury, exceptional hospitality, and a 10-minute shuttle to Seminyak's best spots."}
	/>
	<meta name="keywords" content={seo.data[0].keywords.homekey || 'Trans Resort Bali'} />

	<!-- Open Graph Metadata -->
	<meta property="og:title" content={seo.data[0].og_title.homeogtit || 'The Trans Resort Bali'} />
	<meta
		property="og:description"
		content={seo.data[0].og_description.homeogdesc ||
			"Stay at The Trans Resort Bali, just 10km from Ngurah Rai Airport. Enjoy luxury, exceptional hospitality, and a 10-minute shuttle to Seminyak's best spots."}
	/>
	<meta name="og:image" content={seo.data[0].images_home[0]?.path || ''} />

	<!-- Twitter Card Metadata -->
	<meta name="twitter:card" content="summary_large_image" />
	<meta
		name="twitter:title"
		content={seo.data[0].twitter_title.hometwitit || 'The Trans Resort Bali'}
	/>
	<meta
		name="twitter:description"
		content={seo.data[0].twitter_desciption.hometwitdesc ||
			"Stay at The Trans Resort Bali, just 10km from Ngurah Rai Airport. Enjoy luxury, exceptional hospitality, and a 10-minute shuttle to Seminyak's best spots."}
	/>
	<meta name="twitter:image" content={seo.data[0].images_home[0]?.path || ''} />
</svelte:head>

<Navbar data={information} />
<PopUp />

<section
	class="relative bg-cover bg-center h-screen bg-black/30 bg-blend-overlay md:h-[650px] lg:h-screen lg:overflow-hidden"
	style="background-image: url('{information.data[0].images_hero[0].path}');"
>
	<div class="absolute top-6 w-24 !left-1/2 !-translate-x-1/2 lg:hidden">
		<img
			class="block"
			src={information.data[0].logo_white[0].path}
			alt="Trans Resort Logo"
			loading="lazy"
		/>
	</div>
	<!-- <div class="h-full flex flex-col justify-center container mx-auto px-5 lg:px-32">
		<h1
			data-aos={isDesktop ? 'fade-left' : ''}
			class="text-white Elmessiri text-4xl font-serif md:text-start md:text-5xl lg:text-6xl"
		>
			Immerse into a tropical paradise
		</h1>
		<p
			data-aos={isDesktop ? 'fade-right' : ''}
			class="text-white font-light mt-4 md:text-end md:text-xl lg:text-4xl"
		>
			by staying at The Trans Resort Bali
		</p>
	</div> -->
</section>

<!-- Desktop -->
<!-- <section class="h-full w-full relative flex-col items-center justify-center lg:flex hidden">
	<div class="swiper myHeroSwiper relative h-full w-full">
		<div class="swiper-wrapper">
			{#each information.data[0].desktop_homepage as img}
				<div class="swiper-slide aspect-video">
					<img src="{img?.path}" class="h-full w-full object-center object-cover" alt="trans resort bali">
					<div class="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-black/10 to-transparent"></div>
				</div>
			{/each}
		</div>
	</div>
</section> -->

<!-- Mobile -->
<!-- <section class="h-full w-full relative flex-col items-center justify-center lg:hidden flex">
	<div class="swiper myHeroSwiperMobile relative h-full w-full">
		<div class="swiper-wrapper">
			{#each information.data[0].mobile_homepage as img}
				<div class="swiper-slide aspect-[9/16]">
					<img src="{img?.path}" class="h-full w-full object-center object-cover" alt="trans resort bali">
					<div class="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-black/10 to-transparent"></div>
				</div>
			{/each}
		</div>
	</div>
	<div class="absolute top-6 w-24 !left-1/2 !-translate-x-1/2 lg:hidden z-10">
		<img
			class="block"
			src={information.data[0].logo_white[0].path}
			alt="Trans Resort Logo"
			loading="lazy"
		/>
	</div>
</section> -->

<section class="py-16 lg:py-32">
	<div data-aos={isDesktop ? 'fade-up' : ''} class="mx-auto max-w-screen-2xl px-6 text-center">
		<h2 class="font-serif Elmessiri text-3xl text-[#7D704F] font-medium lg:text-6xl">
			A Leading Five-star Resort
		</h2>
		<p class="text-[#7D704F] mt-3 lg:text-2xl">for Business and Leisure</p>
	</div>
</section>
<section>
	<div
		class="mx-auto container px md:grid md:grid-cols-2 md:gap-x-16 px-5 lg:px-20 lg:gap-x-24 lg:items-center"
	>
		<div
			data-aos={isDesktop ? 'fade-right' : ''}
			class="bg-cover bg-center aspect-[3/4] rounded-xl lg:aspect-[14/16]"
			style="background-image: url('{information.data[0].images_hero[1].path}')"
		></div>
		<div data-aos={isDesktop ? 'fade-up' : ''} class="mt-10">
			<h2 class="font-serif Elmessiri text-2xl text-[#7D704F] font-medium lg:text-5xl">
				Situated in the middle of the lively and stylish area of Seminyak
			</h2>
			<p class="text-minditext mt-2 lg:mt-10 lg:leading-loose lg:text-md">
				Conveniently located just 10 km from I Gusti Ngurah Rai International Airport, The Trans
				Resort Bali offers seamless access to Seminyak’s vibrant dining scene, designer boutiques,
				shopping centers, and entertainment hubs. Our complimentary shuttle service ensures a quick
				5-minute ride to the heart of Seminyak.
			</p>
			<p class="text-minditext mt-2 lg:mt-4 lg:leading-loose lg:text-md">
				As a Halal-friendly destination, our No-Pork, No-Lard restaurant provides a diverse and
				inclusive dining experience, allowing guests to savor world-class culinary delights with
				confidence. Committed to setting new standards of luxury, we combine authentic Indonesian
				hospitality with exceptional service, offering an immersive tropical retreat. From elegant
				accommodations to outstanding resort facilities, every moment at The Trans Resort Bali is
				designed for an unforgettable stay.
			</p>
		</div>
	</div>
</section>
<section class="md:container mx-auto lg:px-20 pb-4 mt-10 lg:py-24 lg:overflow-hidden">
	<div data-aos={isDesktop ? 'fade-left' : ''} class="md:grid md:grid-cols-3 lg:grid-cols-7 gap-10">
		<div class="lg:col-span-2 px-5 md:px-0">
			<h2 class="font-serif font-medium text-[#7d704f] text-2xl md:text-3xl lg:text-5xl">
				Rooms &amp; Villas
			</h2>
			<p class="mt-2 text-[#7d704f]">
				Unwind in one of the world’s best island destinations, with all the space you need to make
				it feel like your own home in this patch of Bali paradise.
			</p>
			<div class="hidden md:flex mt-4">
				<!-- Previous Button -->
				<button
					class="flex items-center justify-center rounded-full focus:outline-none"
					on:click={goRoomPrev}
					aria-label="Previous Slide"
				>
					<svg
						class="!w-24 !h-24 !fill-[#7d704f] md:!fill-[#7d704f]"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 256 256"
					>
						<path
							d="M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm44-92a4,4,0,0,1-4,4H97.66l25.17,25.17a4,4,0,0,1-5.66,5.66l-32-32a4,4,0,0,1,0-5.66l32-32a4,4,0,0,1,5.66,5.66L97.66,124H168A4,4,0,0,1,172,128Z"
						></path>
					</svg>
				</button>

				<!-- Next Button -->
				<button
					class="flex items-center justify-center rounded-full focus:outline-none"
					on:click={goRoomNext}
					aria-label="Next Slide"
				>
					<svg
						class="!w-24 !h-24 !fill-[#7d704f] md:!fill-[#7d704f]"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 256 256"
					>
						<path
							d="M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm42.83-94.83a4,4,0,0,1,0,5.66l-32,32a4,4,0,0,1-5.66-5.66L158.34,132H88a4,4,0,0,1,0-8h70.34L133.17,98.83a4,4,0,0,1,5.66-5.66Z"
						></path>
					</svg>
				</button>
			</div>
		</div>
		<div class="lg:col-span-5 mt-5 md:mt-0">
			<div id="destination-card" class="2xl:container 2xl:mx-auto mx-6 lg:mx-0 hidden md:block">
				<Splide
					bind:this={splideRefRoom}
					options={{
						rewind: false,
						gap: 5,
						perPage: 2,
						type: 'slide',
						arrows: false,
						pagination: false,
						breakpoints: {
							1024: {
								perPage: 2,
								gap: 10
							},
							768: {
								perPage: 1,
								gap: 5
							},
							480: {
								perPage: 1,
								gap: 0
							}
						}
					}}
				>
					{#if room.length > 0}
						{#each room as room, index}
							<SplideSlide>
								<div
									class="aspect-[4/5] rounded-xl overflow-hidden bg-cover bg-center bg-blend-overlay bg-black/40 p-6 flex flex-col"
									style="background-image: url({room?.images[0]?.path})"
								>
									<div class="mt-auto">
										<h2 class="text-white font-serif font-semibold text-left text-2xl">
											{room?.name}
										</h2>
										<ul class="text-white mt-2 font-light space-y-1.5">
											<li class="flex items-center space-x-2">
												<svg
													class="w-4 h-4 fill-white"
													xmlns="http://www.w3.org/2000/svg"
													width="32"
													height="32"
													fill="#000000"
													viewBox="0 0 256 256"
													><path
														d="M214,48V96a6,6,0,0,1-12,0V62.48l-53.76,53.76a6,6,0,0,1-8.48-8.48L193.52,54H160a6,6,0,0,1,0-12h48A6,6,0,0,1,214,48ZM107.76,139.76,54,193.52V160a6,6,0,0,0-12,0v48a6,6,0,0,0,6,6H96a6,6,0,0,0,0-12H62.48l53.76-53.76a6,6,0,0,0-8.48-8.48Z"
													></path></svg
												>
												<span class="text-xs">{room?.size}</span>
											</li>
											<li class="flex items-center space-x-2">
												<svg
													xmlns="http://www.w3.org/2000/svg"
													class="w-4 h-4"
													fill="#ffffff"
													viewBox="0 0 256 256"
													><path
														d="M216,74H30V48a6,6,0,0,0-12,0V208a6,6,0,0,0,12,0V174H242v34a6,6,0,0,0,12,0V112A38,38,0,0,0,216,74ZM30,86h76v76H30Zm88,76V86h98a26,26,0,0,1,26,26v50Z"
													></path></svg
												>
												<span class="text-xs">{room?.type}</span>
											</li>
											<li class="flex items-center space-x-2">
												<svg
													class="w-4 h-4 fill-white"
													xmlns="http://www.w3.org/2000/svg"
													width="32"
													height="32"
													fill="#000000"
													viewBox="0 0 256 256"
													><path
														d="M112.6,158.43a58,58,0,1,0-57.2,0A93.83,93.83,0,0,0,5.21,196.72a6,6,0,0,0,10.05,6.56,82,82,0,0,1,137.48,0,6,6,0,0,0,10-6.56A93.83,93.83,0,0,0,112.6,158.43ZM38,108a46,46,0,1,1,46,46A46.06,46.06,0,0,1,38,108Zm211,97a6,6,0,0,1-8.3-1.74A81.8,81.8,0,0,0,172,166a6,6,0,0,1,0-12,46,46,0,1,0-17.08-88.73,6,6,0,1,1-4.46-11.14,58,58,0,0,1,50.14,104.3,93.83,93.83,0,0,1,50.19,38.29A6,6,0,0,1,249,205Z"
													></path></svg
												>
												<span class="text-xs">{room?.occupancy}</span>
											</li>
										</ul>
										<a
											href="room-villa/{room?.slug}"
											class="btn-primary-border !text-white mt-6 text-center !block !border-white px-5 py-3"
											>View details</a
										>
									</div>
								</div>
							</SplideSlide>
						{/each}
					{/if}
				</Splide>
			</div>
			<div class="2xl:container 2xl:mx-auto mx-0 block md:hidden">
				<Splide
					options={{
						rewind: false,
						gap: 5,
						perPage: 2,
						type: 'slide',
						arrows: true,
						pagination: false,
						breakpoints: {
							1024: {
								perPage: 2,
								gap: 10
							},
							768: {
								perPage: 1,
								gap: 10,
								padding: { right: '10%', left: '7%' }
							},
							480: {
								perPage: 1,
								gap: 10,
								padding: { right: '10%', left: '7%' }
							}
						}
					}}
				>
					{#if room.length > 0}
						{#each room as room, index}
							<SplideSlide>
								<div
									class="aspect-[4/6] rounded-xl overflow-hidden bg-cover bg-center bg-blend-overlay bg-black/40 p-6 flex flex-col"
									style="background-image: url({room?.images[0]?.path})"
								>
									<div class="mt-auto">
										<h2 class="text-white font-serif font-semibold text-left text-2xl">
											{room?.name}
										</h2>
										<ul class="text-white mt-2 font-light space-y-1.5">
											<li class="flex items-center space-x-2">
												<svg
													class="w-4 h-4 fill-white"
													xmlns="http://www.w3.org/2000/svg"
													width="32"
													height="32"
													fill="#000000"
													viewBox="0 0 256 256"
													><path
														d="M214,48V96a6,6,0,0,1-12,0V62.48l-53.76,53.76a6,6,0,0,1-8.48-8.48L193.52,54H160a6,6,0,0,1,0-12h48A6,6,0,0,1,214,48ZM107.76,139.76,54,193.52V160a6,6,0,0,0-12,0v48a6,6,0,0,0,6,6H96a6,6,0,0,0,0-12H62.48l53.76-53.76a6,6,0,0,0-8.48-8.48Z"
													></path></svg
												>
												<span class="text-xs">{room?.size}</span>
											</li>
											<li class="flex items-center space-x-2">
												<svg
													xmlns="http://www.w3.org/2000/svg"
													class="h-4 w-4"
													fill="#ffffff"
													viewBox="0 0 256 256"
													><path
														d="M216,74H30V48a6,6,0,0,0-12,0V208a6,6,0,0,0,12,0V174H242v34a6,6,0,0,0,12,0V112A38,38,0,0,0,216,74ZM30,86h76v76H30Zm88,76V86h98a26,26,0,0,1,26,26v50Z"
													></path></svg
												>
												<span class="text-xs">{room?.type}</span>
											</li>
											<li class="flex items-center space-x-2">
												<svg
													class="w-4 h-4 fill-white"
													xmlns="http://www.w3.org/2000/svg"
													width="32"
													height="32"
													fill="#000000"
													viewBox="0 0 256 256"
													><path
														d="M112.6,158.43a58,58,0,1,0-57.2,0A93.83,93.83,0,0,0,5.21,196.72a6,6,0,0,0,10.05,6.56,82,82,0,0,1,137.48,0,6,6,0,0,0,10-6.56A93.83,93.83,0,0,0,112.6,158.43ZM38,108a46,46,0,1,1,46,46A46.06,46.06,0,0,1,38,108Zm211,97a6,6,0,0,1-8.3-1.74A81.8,81.8,0,0,0,172,166a6,6,0,0,1,0-12,46,46,0,1,0-17.08-88.73,6,6,0,1,1-4.46-11.14,58,58,0,0,1,50.14,104.3,93.83,93.83,0,0,1,50.19,38.29A6,6,0,0,1,249,205Z"
													></path></svg
												>
												<span class="text-xs">{room?.occupancy}</span>
											</li>
										</ul>
										<a
											href="/room-villa"
											class="btn-primary-border !text-white mt-6 text-center !block !border-white px-5 py-3"
											>View details</a
										>
									</div>
								</div>
							</SplideSlide>
						{/each}
					{/if}
				</Splide>
			</div>
		</div>
	</div>
</section>
<section class="hidden lg:block overflow-hidden">
	<div class="mx-auto container px-5 lg:px-20 grid grid-cols-3">
		<div
			data-aos={isDesktop ? 'fade-left' : ''}
			class="bg-cover bg-center h-[500px] overflow-hidden rounded-xl"
			style="background-image: url('{information.data[0].images_hero[2].path}')"
		></div>
		<div data-aos={isDesktop ? 'zoom-in-up' : ''} class="text-center px-7 py-10">
			<h2 class="text-[#7D704F] font-serif text-5xl text-center">The 18th Rooftop</h2>
			<p class="text-[#7D704F] text-center text-sm mt-8">
				Bali Best Kept Secret in Seminyak, The 18th Rooftop a newly stylish open air rooftop bar
				featuring sunset views over the Seminyak landmark, that quickly becomes a favorite amongst
				globetrotters alike for its enchanting setting, tapas and signature cocktails
			</p>
			<a
				class="bg-transparent border-[1px] border-[#7d704f] hover:bg-[#7d704f] text-[#7d704f] hover:text-white px-5 py-3 uppercase !inline-block mt-16"
				href="https://www.transresortbali.com/dining/18th-rooftop"
			>
				View Details
			</a>
		</div>
		<div
			data-aos={isDesktop ? 'fade-right' : ''}
			class="bg-cover bg-left h-[500px] overflow-hidden rounded-xl"
			style="background-image: url('https://transresortbali.com/cms/storage/app/uploads/public/674/43f/a81/67443fa813bab340884299.webp')"
		></div>
	</div>
</section>
<section
	class="py-24 bg-cover bg-left bg-blend-overlay bg-black/40 mt-10 lg:hidden"
	style="background-image: url('https://transresortbali.com/cms/storage/app/uploads/public/674/43f/a81/67443fa813bab340884299.webp');"
>
	<div class="px-6 md:px-10 text-center">
		<h2 class="text-white font-serif text-3xl text-center">The 18th Rooftop</h2>
		<p class="text-white text-center mt-20">
			Bali Best Kept Secret in Seminyak, The 18th Rooftop a newly stylish open air rooftop bar
			featuring sunset views over the Seminyak landmark, that quickly becomes a favorite amongst
			globetrotters alike for its enchanting setting, tapas and signature cocktails
		</p>
		<a
			class="btn-primary-border uppercase !text-white !border-white !inline-block mt-6 px-5 py-3"
			href="https://www.transresortbali.com/dining/18th-rooftop"
		>
			View Details
		</a>
	</div>
</section>
<section class="md:container mx-auto px-5 lg:px-20 pb-4 mt-10 lg:py-24 lg:overflow-hidden">
	<div class="md:grid md:grid-cols-3 lg:grid-cols-7 gap-10">
		<div class="lg:col-span-2 px-5 md:px-0">
			<h2 class="font-serif font-medium text-[#7d704f] text-2xl md:text-3xl lg:text-5xl">
				Special Offers
			</h2>
			<p class="my-2 text-[#7d704f]">
				Experience more and pay less with our special offers and best rate guarantee!
			</p>
			<div class="hidden md:flex mt-4">
				<!-- Previous Button -->
				<button
					class="flex items-center justify-center rounded-full focus:outline-none"
					on:click={goPrev}
					aria-label="Previous Slide"
				>
					<svg
						class="!w-24 !h-24 !fill-[#7d704f] md:!fill-[#7d704f]"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 256 256"
					>
						<path
							d="M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm44-92a4,4,0,0,1-4,4H97.66l25.17,25.17a4,4,0,0,1-5.66,5.66l-32-32a4,4,0,0,1,0-5.66l32-32a4,4,0,0,1,5.66,5.66L97.66,124H168A4,4,0,0,1,172,128Z"
						></path>
					</svg>
				</button>

				<!-- Next Button -->
				<button
					class="flex items-center justify-center rounded-full focus:outline-none"
					on:click={goNext}
					aria-label="Next Slide"
				>
					<svg
						class="!w-24 !h-24 !fill-[#7d704f] md:!fill-[#7d704f]"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 256 256"
					>
						<path
							d="M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm42.83-94.83a4,4,0,0,1,0,5.66l-32,32a4,4,0,0,1-5.66-5.66L158.34,132H88a4,4,0,0,1,0-8h70.34L133.17,98.83a4,4,0,0,1,5.66-5.66Z"
						></path>
					</svg>
				</button>
			</div>
		</div>
		<div class="lg:col-span-5">
			<div id="destination-card" class="2xl:container 2xl:mx-auto md:mx-6 lg:mx-0">
				<Splide
					bind:this={splideRef}
					options={{
						rewind: false,
						gap: 5,
						perPage: 2,
						type: 'slide',
						arrows: false,
						pagination: false,
						breakpoints: {
							1024: {
								perPage: 2,
								gap: 10
							},
							768: {
								perPage: 1,
								gap: 10,
								padding: { right: '15%', left: '5%' }
							},
							480: {
								perPage: 1,
								gap: 10,
								padding: { right: '15%', left: '5%' }
							}
						}
					}}
				>
					{#if offer.length > 0}
						{#each offer as offer, index}
							<SplideSlide>
								<div
									class="block aspect-square w-full shrink-0 basis-11/12 snap-always snap-center text-center"
								>
									<div
										class="aspect-square rounded-xl bg-cover bg-center w-full"
										style="background-image: url({offer?.images[0]?.path})"
									></div>

									<a
										href="/offer"
										class="text-sm uppercase text-minditext mt-3 inline-block py-3 px-5 bg-[#7d704f] hover:bg-[#827668] transition-all duration-300 text-white"
									>
										View details
									</a>
								</div>
							</SplideSlide>
						{/each}
					{/if}
				</Splide>
			</div>
		</div>
	</div>
</section>
<Footer data={information} />
